var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClearHover = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7750",
    "data-name": "Group 7750",
    transform: "translate(-487.797 -199.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8988",
    "data-name": "Rectangle 8988",
    width: 22,
    height: 22,
    rx: 4,
    transform: "translate(487.797 199.426)",
    fill: "#cdd6ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(494.796 206.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M11.854,4.146a.5.5,0,0,1,0,.708l-7,7a.5.5,0,1,1-.708-.708l7-7a.5.5,0,0,1,.708,0Z",
    transform: "translate(-3.999 -3.999)",
    fill: "#444a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M4.146,4.146a.5.5,0,0,0,0,.708l7,7a.5.5,0,1,0,.708-.708l-7-7a.5.5,0,0,0-.708,0Z",
    transform: "translate(-3.999 -3.999)",
    fill: "#444a58"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClearHover);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZyBpZD0iR3JvdXBfNzc1MCIgZGF0YS1uYW1lPSJHcm91cCA3NzUwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg3Ljc5NyAtMTk5LjQyNikiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV84OTg4IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA4OTg4IiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHJ4PSI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0ODcuNzk3IDE5OS40MjYpIiBmaWxsPSIjY2RkNmVhIi8+CiAgICA8ZyBpZD0ieCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDk0Ljc5NiAyMDYuNTk4KSI+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzE0MTgiIGRhdGEtbmFtZT0iUGF0aCAxNDE4IiBkPSJNMTEuODU0LDQuMTQ2YS41LjUsMCwwLDEsMCwuNzA4bC03LDdhLjUuNSwwLDEsMS0uNzA4LS43MDhsNy03YS41LjUsMCwwLDEsLjcwOCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuOTk5IC0zLjk5OSkiIGZpbGw9IiM0NDRhNTgiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMTQxOSIgZGF0YS1uYW1lPSJQYXRoIDE0MTkiIGQ9Ik00LjE0Niw0LjE0NmEuNS41LDAsMCwwLDAsLjcwOGw3LDdhLjUuNSwwLDEsMCwuNzA4LS43MDhsLTctN2EuNS41LDAsMCwwLS43MDgsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjk5OSAtMy45OTkpIiBmaWxsPSIjNDQ0YTU4Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";